export enum UserCapabilityGroup {
  Contracts = 'contracts',
  Policyholders = 'policyholders',
  Tenants = 'tenants',
  ExternalUsers = 'external_users',
  InternalUsers = 'internal_users',
  LinkBuilder = 'link_builder',
  ProviderSettings = 'provider_settings',
  Administrative = 'administrative',
}
